import { Injectable, OnDestroy } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

import { ApAccordionItemComponent } from './item/item.component';

@Injectable()
export class ApAccordionService implements OnDestroy {
    public itemRegistered$: Observable<ApAccordionItemComponent>;

    private readonly accordionItemComponent: ApAccordionItemComponent[] = [];
    private readonly itemRegisteredSubject: ReplaySubject<ApAccordionItemComponent>;

    constructor() {
        this.itemRegisteredSubject = new ReplaySubject();
        this.itemRegistered$ = this.itemRegisteredSubject.asObservable();
    }

    public get accordionItems(): ApAccordionItemComponent[] {
        return this.accordionItemComponent;
    }

    public ngOnDestroy(): void {
        this.itemRegisteredSubject.complete();
    }

    public register(item: ApAccordionItemComponent): void {
        this.accordionItems.push(item);
        this.itemRegisteredSubject.next(item);
    }

    public unregister(item: ApAccordionItemComponent): void {
        this.accordionItems.splice(this.accordionItems.indexOf(item), 1);
    }
}
